import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Icon from "@ui-kit/icons/Icon.web";
import type { FormattedRating } from "../types/ratings";

interface RatingDisplayProps {
  rating?: FormattedRating | null;
  fontSize?: string | Record<string, string>;
  onClick?: () => void;
  "data-testid"?: string;
}

export function RatingDisplay({
  rating,
  fontSize = "sm",
  onClick,
  "data-testid": testId = "organizer-rating",
}: RatingDisplayProps): JSX.Element | null {
  if (!rating) return null;

  const { average, total } = rating;

  return (
    <Flex
      as={onClick ? "button" : "div"}
      role={onClick ? "button" : undefined}
      alignItems="center"
      gap="2xs"
      ml="xs"
      cursor={onClick ? "pointer" : "default"}
      onClick={onClick}
      data-testid={testId}
    >
      <Icon name="BasicStar" color="yellow.400" w="element.md" h="element.md" />
      <Text fontSize={fontSize} color="fg.muted" fontWeight="500">
        {`${average} (${total})`}
      </Text>
    </Flex>
  );
}
